import styled from 'styled-components';
import { rem } from 'polished';
import { compareTableColumns } from '../index.styles';

export const SectionContainer = styled.section`
  grid-column: 1 / -1;
  display: grid;
  ${compareTableColumns}
  row-gap: ${rem(8)};
  margin-bottom: ${rem(48)};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SectionHeaderWrapper = styled.div`
  grid-column: 1;
  width: max-content;
`;

export const EntitlementList = styled.div`
  grid-column: 1 / -1;
  border: 1px solid #e2e4e7;
  border-radius: ${rem(12)};
  overflow: hidden;
`;

export const FeatureRow = styled.div`
  ${compareTableColumns}
  align-items: center;
  padding: ${rem(16)} 0;

  &:not(:last-child) {
    border-bottom: 1px solid #e2e4e7;
  }
`;

export const FeatureName = styled.div`
  grid-column: 1;
  min-width: 0;
  padding-left: ${rem(12)};
  display: flex;
  align-items: center;

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    padding-left: ${rem(16)};
  }
`;

export const FeatureNameButton = styled.button`
  display: block;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  text-align: left;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  cursor: pointer;

  &:focus-visible {
    outline: 0.125rem solid ${({ theme }) => theme.color.ui.blue[70]};
    outline-offset: 0.125rem;
    border-radius: 0.125rem;
  }
`;

export const FeatureNameText = styled.span`
  font-size: ${rem(16)};
  font-weight: 500;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.color.ui.grey[100]};
`;

/** Keeps a label's final word and its info icon on the same line — see `splitTrailingWord`. */
export const FeatureNameLastWord = styled.span`
  white-space: nowrap;
`;

export const FeatureToolTip = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: ${rem(8)};
  white-space: nowrap;
`;

export const FeatureValueCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 0 ${rem(8)};
  position: relative;
  align-self: stretch;
`;

export const CellAnnouncement = styled.p`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  user-select: none;
`;